import { render } from "./ContentCopy.vue.js?vue&type=template&id=0e8bd3c4!=!../vue-loader/dist/index.js??ruleSet[0]!./ContentCopy.vue?vue&type=template&id=0e8bd3c4"
import script from "./ContentCopy.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./ContentCopy.vue?vue&type=script&lang=js"
export * from "./ContentCopy.vue.js?vue&type=script&lang=js!=!../vue-loader/dist/index.js??ruleSet[0]!./ContentCopy.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__